module.exports = require("@mario-kart/domain").metadata;
